"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _MarketDataCardComponent = _interopRequireDefault(require("./MarketDataCardComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
require("./MarketDataCardsComponent.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('market-data-cards');
var MarketDataCardsComponent = function MarketDataCardsComponent(props) {
  var level1 = props.level1,
    instruments = props.instruments,
    products = props.products;
  var marketDataCards = instruments.map(function (instrument) {
    var InstrumentId = instrument.InstrumentId;
    var level1Data = level1[InstrumentId];
    if (!level1Data) return null;
    var Product1 = instrument.Product1,
      Product2 = instrument.Product2;
    var product1 = products.find(function (x) {
      return x.ProductId === Product1;
    });
    var product2 = products.find(function (x) {
      return x.ProductId === Product2;
    });
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: InstrumentId,
      className: "".concat(bemClasses('card'), " container-with-shadow")
    }, /*#__PURE__*/_react["default"].createElement(_MarketDataCardComponent["default"], {
      instrument: instrument,
      product1: product1,
      product2: product2,
      level1Data: level1Data
    }));
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemClasses('row')
  }, marketDataCards));
};
var _default = exports["default"] = MarketDataCardsComponent;